import styled from "styled-components";

export const PDFContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f8f9fa;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 0; /* cria um contexto de empilhamento para evitar sobreposição fora do container */
`;

export const PDFHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background: #fff;
  border-bottom: 1px solid #e9ecef;

  h5 {
    margin: 0;
    color: #495057;
    font-weight: 600;
    
    i {
      color: #dc3545;
    }
  }
`;

export const CompetenciaIndicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${props => props.color || '#ff6b6b'};
  color: white;
  font-size: 18px;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
`;

export const PDFWrapper = styled.div`
  flex: 1;
  position: relative;
  overflow: auto;
  background: #fff;
  height: 100%;
  min-height: 0;
  padding-bottom: 160px; /* Espaço para o resumo e botão */

  .PdfHighlighter {
    height: 100%;
    width: 100%;
  }

  .PdfHighlighter__tip {
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 1000;

    input {
      border: 1px solid #ddd;
      border-radius: 4px;
      padding: 8px 12px;
      width: 200px;
      margin-bottom: 8px;
      font-size: 14px;

      &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
      }
    }

    button {
      background: #007bff;
      color: white;
      border: none;
      border-radius: 4px;
      padding: 6px 12px;
      cursor: pointer;
      font-size: 12px;
      margin-right: 5px;

      &:hover {
        background: #0056b3;
      }
    }
  }

  .PdfHighlighter__highlight {
    transition: all 0.2s ease;

    &:hover {
      opacity: 0.8 !important;
    }
  }
`;

export const PopupContent = styled.div`
  .highlight-popup {
    background: white;
    border-radius: 8px;
    padding: 12px;
    min-width: 200px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border: 1px solid #e9ecef;
  }

  .popup-header {
    margin-bottom: 8px;
    
    .competencia-badge {
      background: #f8f9fa;
      color: #495057;
      padding: 4px 8px;
      border-radius: 12px;
      font-size: 11px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
  }

  .popup-comment {
    color: #6c757d;
    font-size: 13px;
    line-height: 1.4;
    margin-bottom: 10px;
    max-width: 250px;
    word-wrap: break-word;
  }

  .popup-actions {
    display: flex;
    justify-content: flex-end;
    
    .btn {
      padding: 4px 8px;
      font-size: 12px;
      
      &:hover {
        transform: translateY(-1px);
      }
    }
  }
`;

export const HighlightsSummary = styled.div`
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-top: 1px solid #e9ecef;
  padding: 15px 20px;
  max-height: 150px;
  min-height: 100px;
  overflow-y: auto;
  position: absolute;
  bottom: 60px;
  left: 0;
  right: 0;
  z-index: 10;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);

  h6 {
    margin: 0 0 10px 0;
    color: #495057;
    font-weight: 600;
    font-size: 14px;
  }
`;

export const HighlightItem = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 0;
  border-bottom: 1px solid #f8f9fa;
  position: relative;

  &:last-child {
    border-bottom: none;
  }

  /* Indicador visual para marcações não salvas */
  ${props => !props.saved && `
    &::before {
      content: '';
      position: absolute;
      left: -10px;
      top: 50%;
      transform: translateY(-50%);
      width: 6px;
      height: 6px;
      background: #ffc107;
      border-radius: 50%;
      box-shadow: 0 0 0 2px rgba(255, 193, 7, 0.3);
      animation: pulse 2s infinite;
    }
    
    background: rgba(255, 193, 7, 0.05);
    border-left: 3px solid #ffc107;
    padding-left: 12px;
  `}

  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.7);
    }
    70% {
      box-shadow: 0 0 0 6px rgba(255, 193, 7, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(255, 193, 7, 0);
    }
  }

  .highlight-header {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }

  .highlight-emoji {
    margin-right: 10px;
    font-size: 16px;
  }

  .highlight-image {
    margin-bottom: 8px;
    
    img {
      display: block;
      max-width: 100%;
      height: auto;
      border-radius: 4px;
      border: 1px solid #ddd;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
  }

  .highlight-text {
    color: #495057;
    font-size: 13px;
    margin-bottom: 6px;
    line-height: 1.4;
    word-wrap: break-word;
  }

  .highlight-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .highlight-competencia {
    color: #6c757d;
    font-size: 11px;
    text-transform: uppercase;
    font-weight: 600;
    letter-spacing: 0.5px;
    background: #f8f9fa;
    padding: 2px 6px;
    border-radius: 8px;
  }

  .unsaved-indicator {
    color: #ffc107;
    font-size: 12px;
    font-weight: 600;
    margin-left: 8px;
    display: flex;
    align-items: center;
    
    i {
      margin-right: 4px;
      animation: pulse 2s infinite;
    }
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  background: #f8f9fa;
  border-radius: 8px;
`;

export const ErrorContainer = styled.div`
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  text-align: center;

  .alert {
    margin: 0;
  }
`;

export const SaveButton = styled.button`
  background: #28a745;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.2);
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 11;
  border-radius: 0;

  &:hover:not(:disabled) {
    background: #218838;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);
  }

  &:disabled {
    background: #6c757d;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }

  i {
    margin-right: 8px;
  }

  .fa-spinner {
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;